import {env} from '@/config';
import keycloakAxios from '@/services/axios';
import {Payment} from '@/types/payments';

const {VERSION} = env;
export const createPayment = async (data: Payment) => {
  const updatedData = {
    ...data,
    billingData: {
      ...data.billingData,
      subscription:
        data.billingData?.subscription === 'no'
          ? null
          : data.billingData?.subscription
    }
  };
  const response = await keycloakAxios.post(
    'payments/payment-intent',
    updatedData,
    {
      headers: {
        'X-App-Version': VERSION,
        'X-App-Platform': 'web'
      }
    }
  );

  if (response.status >= 300) {
    throw new Error(
      `Error creating payment: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
